var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-xs"},[_c('q-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"row-key":"name","hide-bottom":"","flat":"","bordered":"","pagination":{
			rowsPerPage: 10,
		}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }